import React, {useContext, useEffect, useState} from "react";
import "../../sass/main.scss";
import Modal from "react-modal";
import APIHelper from "../../helpers/APIHelper";
import Fn from "../../libraries/Fn";
import axios2 from "../../helpers/APIHelper";

const MvService = (props) => {
	
  window._load = (_page = 1) => {
    try {
      load(_page);
    } catch (e) {
    }
  }

  const [isOpen, setIsOpen] = useState(false);
  const [result, setResult] = useState();

  useEffect(() => {
    document.body.style.overflow = 'auto';
    setIsOpen(props.isOpen);
    if (!props.isOpen) props?.onClose();
  }, [props.isOpen]);

  useEffect(() => {
    if (!isOpen) props?.onClose();
  }, [isOpen]);

  const onToggleModal = () => {
    setIsOpen((prev) => !prev);
  };

  const load = () => {
    // /member/show/all/service/ready?mb_no=1027015
    // /member/show/all/ipkum/ready?mb_no=${props.mbNo}
    axios2
      .post(`/member/show/all/service/ready?mb_no=${props.mbNo}`)
      .then((response) => {
        const {code, message, result, pageInfo} = response?.data;
        if (code === 200) {
          setResult(result);
          console.log(result);
        }
      })
      .catch((error) => {
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
      });
  }

  return (
    <Modal
      isOpen={isOpen}
      style={{
        modal: {
          backgroundColor: 'transparent',
          margin: 0,
          padding: 0,
          alignItems: undefined,
          justifyContent: undefined,
        },
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'transparent'
        }
      }}
      onAfterOpen={() => {
        Fn.centerModal();
        load();
      }}
      onRequestClose={() => setIsOpen(false)}
      ariaHideApp={false}
    >
      <div className="pop_background" style={{zIndex: 1000000000}}>
        <div className="pop_box01 p_absolute_mid_pop" style={{minWidth: '1180px'}}>
          <div className="POP_title">
            <h5><strong>서비스 신청내역</strong></h5>
            <p className="closed">
              <button type="button" className="btn" onClick={() => setIsOpen(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
              </button>
            </p>
          </div>

          <div className="POP_cnt_box w-100">
            <table className="view-rounded sub_table_border mvservice" style={{borderRadius: 0}}>
              <colgroup>
                <col width="70px"/>
                <col width="85px"/>
                <col width="85px"/>
                <col width="180px"/>
                <col width="100px"/>
                <col width="55px"/>
                <col width="100px"/>
                <col width="60px"/>
                <col width="60px"/>
                <col width="*"/>
              </colgroup>
              <tr>
                <th>No</th>
                <th>매출날짜</th>
                <th>시작날짜</th>
                <th>서비스명</th>
                <th>가격</th>
                <th>수량</th>
                <th>기간</th>
                <th>접수자</th>
                <th>등록자</th>
                <th>서비스비고</th>
              </tr>
              {result && result.map((item, index) => {
                let input_txt = '';
                if (item?.ip_cardName) input_txt = item?.ip_method + "(" + item?.ip_cardName + ")";
                else input_txt = item?.ip_method;

                return (
                  <tr>
                    <td className="text-center">{index + 1}<br/>{item?.ck_cnt}<br/>{item?.ap_no}</td>
                    <td className="text-center">{item?.ap_date || ''}</td>
                    <td className="text-center">{item?.start_date || ''}</td>
                    <td className="text-left">{item?.ap_pdtName ? item?.ap_pdtName : item?.it_name}</td>
                    <td className="text-right">{Fn.numberWithCommas(item?.ap_amt)}</td>
                    <td className="text-center">{item?.ap_qty}</td>
                    <td className="text-center">{item?.period ? (item?.period + " " + item?.period_type) : ""}</td>
                    <td className="text-center">{Fn.getNonNull(item?.reg_step)}</td>
                    <td className="text-center">{item?.ap_step}</td>
                    <td className="text-left">{item?.ap_etc}</td>
                  </tr>
                );
              })}

            </table>
          </div>
          <div className="text-center mb-3">
            <button type="button" className="btn btn-sm btn-ligray px-2" onClick={() => setIsOpen(false)}>닫기</button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MvService;
